/* eslint-disable import/no-anonymous-default-export */
import { Error, fetchError, fetchUtils, HttpError } from 'react-admin';
import { stringify } from 'query-string';
import { errorMonitor } from 'events';

const apiUrl = `${process.env.REACT_APP_SERVER_URL}`;
const httpClient = fetchUtils.fetchJson;

const convertFileToBase64 = file =>
	new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.onload = () => resolve(reader.result);
		reader.onerror = reject;

		reader.readAsDataURL(file.rawFile);
	});

export default {
	getList: (resource, params) => {
		const options = {
            headers: new Headers({ Accept: 'application/json' }),
        };
		const token = localStorage.getItem("token")
        if (token) {
            options.headers.set('Authorization', `Bearer ${token}`);
        }
		const { page, perPage } = params.pagination;
		const { field, order } = params.sort;
		const query = {
			sort: JSON.stringify([field, order]),
			range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
			filter: JSON.stringify(params.filter),
		};
		if (resource === 'users') {
			const url = `${apiUrl}/${resource}/getList?${stringify(query)}`;
			const resposne = httpClient(url,options).then(({ headers, json }) => {
				if(json['error']){
				return	Promise.reject((json['error']));
				}
				else{
				return ({
					data: json['users'],
					total: parseInt(json['usersSize'], 10),
					})
					}});
			return resposne
		} else if (resource === 'categories') {
			const url = `${apiUrl}/${resource}/getList?${stringify(query)}`;

			const resposne = httpClient(url,options).then(({ headers, json }) => {
				if(json['error']){
				return	Promise.reject((json['error']));
				}
				else{
				return ({
					data: json['categories'],
					total: parseInt(json['categoriesSize'], 10),
					})
					}});
			return resposne
		} else if (resource === 'items') {
			const defult_format = params.filter;
			let price_range = {};
			let category_type = {};
			let status = {};
			let search = {};
			let new_format = {};
			for (const item in defult_format) {
				if (item.includes('is_')) {
					status = {
						[item]: defult_format[item],
					};
				}
				if (item === 'top' || item === 'bot') {
					price_range[item] = defult_format[item];
				}
				if (item === 'category_id') {
					category_type = {
						[item]: defult_format[item],
					};
				}
				if (item === 'name') {
					search = {
						[item]: defult_format[item],
					};
				}
			}
			new_format = {
				price_range: price_range,
				category_type: category_type,
				status: status,
				search: search,
			};
			const query = {
				sort: JSON.stringify([field, order]),
				range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
				filter: JSON.stringify(new_format),
			};
			const url = `${apiUrl}/${resource}/getList?${stringify(query)}`;

			const resposne = httpClient(url,options).then(({ headers, json }) => {
				if(json['error']){
				return	Promise.reject((json['error']));
				}
				else{
				return ({
					data: json['items'],
					total: parseInt(json['itemsSize'], 10),
					})
					}});
			return resposne
		} else if (resource === 'orders') {
			const url = `${apiUrl}/${resource}/getList?${stringify(query)}`;
			const resposne = httpClient(url,options).then(({ headers, json }) => {
				if(json['error']){
				return	Promise.reject((json['error']));
				}
				else{
				return ({
					data: json['orders'],
					total: parseInt(json['ordersSize'], 10),
					})
					}});
			return resposne
		} else if (resource === 'operations') {
			const url = `${apiUrl}/${resource}/getList?${stringify(query)}`;

			const resposne = httpClient(url,options).then(({ headers, json }) => {
				if(json['error']){
				return	Promise.reject((json['error']));
				}
				else{
				return ({
					data: json['operations'],
					total: parseInt(json['operationsSize'], 10),
					})
					}});
			return resposne
		} else if (resource === 'admins') {
			const url = `${apiUrl}/${resource}/getList?${stringify(query)}`;

			const resposne = httpClient(url,options).then(({ headers, json }) => {
				if(json['error']){
				return	Promise.reject((json['error']));
				}
				else{
				return ({
					data: json['admins'],
					total: parseInt(json['adminssSize'], 10),
					})
					}});
			return resposne
		}
	},

	getOne: (resource, params) => {
		const options = {
            headers: new Headers({ Accept: 'application/json' }),
        };
		const token = localStorage.getItem("token")
        if (token) {
            options.headers.set('Authorization', `Bearer ${token}`);
        }
		const query = {
			id: JSON.stringify(params.id),
		};
		if (resource === 'users') {
			const resposne = httpClient(`${apiUrl}/${resource}/getUser/?${stringify(query)}`,options).then(({ headers, json }) => {
				if(json['error']){
				return	Promise.reject((json['error']));
				}
				else{
				return ({
					data: json['responseData'],
					record: { ...params.data },
					})
					}});
			return resposne
		} else if (resource === 'categories') {
			const resposne = httpClient(`${apiUrl}/${resource}/getCategory/?${stringify(query)}`,options).then(({ headers, json }) => {
				if(json['error']){
				return	Promise.reject((json['error']));
				}
				else{
				return ({
					data: json['responseData'],
					})
					}});
			return resposne
		} else if (resource === 'operations') {
			const resposne = httpClient(`${apiUrl}/${resource}/getOperation/?${stringify(query)}`,options).then(({ headers, json }) => {
				if(json['error']){
				return	Promise.reject((json['error']));
				}
				else{
				return ({
					data: json['responseData'],
					})
					}});
			return resposne
		} else if (resource === 'orders') {
			const resposne = httpClient(`${apiUrl}/${resource}/getOrder/?${stringify(query)}`,options).then(({ headers, json }) => {
				if(json['error']){
				return	Promise.reject((json['error']));
				}
				else{
				return ({
					data: json['responseData'],
					})
					}});
			return resposne
			
		} else if (resource === 'items') {
			const resposne = httpClient(`${apiUrl}/${resource}/getItem/?${stringify(query)}`,options).then(({ headers, json }) => {
				if(json['error']){
				return	Promise.reject((json['error']));
				}
				else{
				return ({
					data: json['responseData'],
					})
					}});
			return resposne
		
		} else if (resource === 'admins') {
			const resposne = httpClient(`${apiUrl}/${resource}/getAdmin/?${stringify(query)}`,options).then(({ headers, json }) => {
				if(json['error']){
				return	Promise.reject((json['error']));
				}
				else{
				return ({
					data: json['responseData'],
					})
					}});
			return resposne
		}
	},
	getMany: (resource, params) => {
		const options = {
            headers: new Headers({ Accept: 'application/json' }),
        };
		const token = localStorage.getItem("token")
        if (token) {
            options.headers.set('Authorization', `Bearer ${token}`);
        }
		if (resource === 'categories') {
			const url = `${apiUrl}/${resource}/getList`;
			const resposne = httpClient(url,options).then(({ headers, json }) => {
				if(json['error']){
				return	Promise.reject((json['error']));
				}
				else{
				return ({
					data: json['categories'],
					})
					}});
			return resposne
		} else if (resource === 'users') {
			const query = {
				ids: JSON.stringify(params.ids),
			};
			const resposne = httpClient(`${apiUrl}/${resource}/getUsers/?${stringify(query)}`,options).then(({ headers, json }) => {
				if(json['error']){
				return	Promise.reject((json['error']));
				}
				else{
				return ({
					data: [...json['responseData']],
					})
					}});
			return resposne
		} else if (resource === 'items') {
			const query = {
				id: JSON.stringify(params.ids[0]),
			};
			const resposne = httpClient(`${apiUrl}/${resource}/getItem/?${stringify(query)}`,options).then(({ headers, json }) => {
				if(json['error']){
				return	Promise.reject((json['error']));
				}
				else{
				return ({
					data: [json['responseData']],
					})
					}});
			return resposne
		}
	},

	getManyReference: (resource, params) => {
		const options = {
            headers: new Headers({ Accept: 'application/json' }),
        };
		const token = localStorage.getItem("token")
        if (token) {
            options.headers.set('Authorization', `Bearer ${token}`);
        }
		const { page, perPage } = params.pagination;
		const { field, order } = params.sort;
		const query = {
			sort: JSON.stringify([field, order]),
			range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
			filter: JSON.stringify({
				...params.filter,
				[params.target]: params.id,
			}),
		};
		const url = `${apiUrl}/${resource}?${stringify(query)}`;
		const resposne = httpClient(url,options).then(({ headers, json }) => {
			if(json['error']){
			return	Promise.reject((json['error']));
			}
			else{
			return ({
				data: json,
				total: parseInt(headers.get('content-range').split('/').pop(), 10),
				})
				}});
		return resposne
	},

	update: (resource, params) => {
		let options = {
            headers: new Headers({ Accept: 'application/json' }),
			method: 'PUT',
			body: JSON.stringify(params.data),
        };
		const token = localStorage.getItem("token")
        if (token) {
            options.headers.set('Authorization', `Bearer ${token}`);
        }
		if (resource === 'users') {
			const resposne = httpClient(`${apiUrl}/${resource}/updateUser`,options).then(({ headers, json }) => {
				if(json['error']){
				return	Promise.reject((json['error']));
				}
				else{
				return ({
					data: json['responseData']
					})
					}});
			return resposne
		} else if (resource === 'categories') {
			const resposne = httpClient(`${apiUrl}/${resource}/updateCategory`,options).then(({ headers, json }) => {
				if(json['error']){
				return	Promise.reject((json['error']));
				}
				else{
				return ({
					data: json['responseData']
					})
					}});
			return resposne
		} else if (resource === 'operations') {
			const resposne = httpClient(`${apiUrl}/${resource}/updateOperation`,options).then(({ headers, json }) => {
				if(json['error']){
				return	Promise.reject((json['error']));
				}
				else{
				return ({
					data: json['responseData']
					})
					}});
			return resposne
		} else if (resource === 'items') {
           
			const newPictures = params.data.images.filter(p => p?.rawFile instanceof File);
			const formerPictures = params.data.images.filter(p => !(p?.rawFile instanceof File));
           
			return Promise.all(newPictures.map(convertFileToBase64))
				.then(base64Pictures =>
					base64Pictures.map(picture64 => ({
						src: picture64,
					})),
				)
				.then(transformedNewPictures => {
					let data = Object.assign({}, params.data, { images: [...transformedNewPictures, ...formerPictures] });
					const newoptions = {
						headers: new Headers({ Accept: 'application/json' }),
						method: 'PUT',
						body: JSON.stringify(data),
					};
					const newtoken = localStorage.getItem("token")
					if (token) {
						newoptions.headers.set('Authorization', `Bearer ${newtoken}`);
					}	
					const resposne = httpClient(`${apiUrl}/${resource}/updateItem`,newoptions).then(({ headers, json }) => {
						if(json['error']){
						return	Promise.reject((json['error']));
						}
						else{
						return ({
							data: json['responseData']
							})
							}});
					return resposne				
				});
		} else if (resource === 'orders') {
			const resposne = httpClient(`${apiUrl}/${resource}/updateOrder`,options).then(({ headers, json }) => {
				if(json['error']){
				return	Promise.reject((json['error']));
				}
				else{
				return ({
					data: json['responseData']
					})
					}});
			return resposne
		} else if (resource === 'admins') {
			const resposne = httpClient(`${apiUrl}/${resource}/updateAdmin`,options).then(({ headers, json }) => {
				if(json['error']){
				return	Promise.reject((json['error']));
				}
				else{
				return ({
					data: json['responseData']
					})
					}});
			return resposne
		}
	},
	updateMany: (resource, params) => {
		let options = {
            headers: new Headers({ Accept: 'application/json' }),
			method: 'PUT',
			body: JSON.stringify(params.data),
        };
		const token = localStorage.getItem("token")
        if (token) {
            options.headers.set('Authorization', `Bearer ${token}`);
        }
		const query = {
			filter: JSON.stringify({ id: params.ids }),
		};
		const resposne = httpClient(`${apiUrl}/${resource}?${stringify(query)}`,options).then(({ headers, json }) => {
			if(json['error']){
			return	Promise.reject((json['error']));
			}
			else{
			return ({
				data: json
				})
				}});
		return resposne
	},

	create: (resource, params) => {
		let options = {
            headers: new Headers({ Accept: 'application/json' }),
			method: 'POST',
			body: JSON.stringify(params.data),
        };
		const token = localStorage.getItem("token")
        if (token) {
            options.headers.set('Authorization', `Bearer ${token}`);
        }
		 if (resource === 'categories') {
			const resposne = httpClient(`${apiUrl}/${resource}/createCategory`,options).then(({ headers, json }) => {
				if(json['error']){
				return	Promise.reject((json['error']));
				}
				else{
				return ({
					data: { ...params.data, id: json.id },
					})
					}});
			return resposne
		} else if (resource === 'admins') {
			const resposne = httpClient(`${apiUrl}/${resource}/createAdmin`,options).then(({ headers, json }) => {
				if(json['error']){
				return	Promise.reject((json['error']));
				}
				else{
				return ({
					data: { ...params.data, id: json.id },
					})
					}});
			return resposne
		}
	},
	delete: (resource, params) => {
		let options = {
            headers: new Headers({ Accept: 'application/json' }),
			method: 'DELETE',
        };
		const token = localStorage.getItem("token")
        if (token) {
            options.headers.set('Authorization', `Bearer ${token}`);
        }
		if (resource === 'users') {
			const resposne = httpClient(`${apiUrl}/${resource}/deleteUser/${params.id}`,options).then(({ headers, json }) => {
				if(json['error']){
				return	Promise.reject((json['error']));
				}
				else{
				return ({
					data: params.id 
					})
					}});
			return resposne
		} else if (resource === 'categories') {
			const resposne = httpClient(`${apiUrl}/${resource}/deleteCategory/${params.id}`,options).then(({ headers, json }) => {
				if(json['error']){
				return	Promise.reject((json['error']));
				}
				else{
				return ({
					data: params.id 
					})
					}});
			return resposne
		} else if (resource === 'operations') {
			const resposne = httpClient(`${apiUrl}/${resource}/deleteOperation/${params.id}`,options).then(({ headers, json }) => {
				if(json['error']){
				return	Promise.reject((json['error']));
				}
				else{
				return ({
					data: params.id 
					})
					}});
			return resposne
		} else if (resource === 'items') {
			const resposne = httpClient(`${apiUrl}/${resource}/deleteItem/${params.id}`,options).then(({ headers, json }) => {
				if(json['error']){
				return	Promise.reject((json['error']));
				}
				else{
				return ({
					data: params.id 
					})
					}});
			return resposne
		} else if (resource === 'orders') {
			const resposne = httpClient(`${apiUrl}/${resource}/deleteOrder/${params.id}`,options).then(({ headers, json }) => {
				if(json['error']){
				return	Promise.reject((json['error']));
				}
				else{
				return ({
					data: params.id 
					})
					}});
			return resposne
		} else if (resource === 'admins') {
			const resposne = httpClient(`${apiUrl}/${resource}/deleteAdmin/${params.id}`,options).then(({ headers, json }) => {
				if(json['error']){
				return	Promise.reject((json['error']));
				}
				else{
				return ({
					data: params.id 
					})
					}});
			return resposne
		}
	},
	deleteMany: (resource, params) => {
		let options = {
            headers: new Headers({ Accept: 'application/json' }),
			method: 'DELETE',
        };
		const token = localStorage.getItem("token")
        if (token) {
            options.headers.set('Authorization', `Bearer ${token}`);
        }
		const query = {
			filter: JSON.stringify({ id: params.ids }),
		};
		if (resource === 'users') {
			const resposne = httpClient(`${apiUrl}/${resource}/deleteUserList?${stringify(query)}`,options).then(({ headers, json }) => {
				if(json['error']){
				return	Promise.reject((json['error']));
				}
				else{
				return ({
					data: params.ids 
					})
					}});
			return resposne
		} else if (resource === 'categories') {
			const resposne = httpClient(`${apiUrl}/${resource}/deleteCategoryList?${stringify(query)}`,options).then(({ headers, json }) => {
				if(json['error']){
				return	Promise.reject((json['error']));
				}
				else{
				return ({
					data: params.ids 
					})
					}});
			return resposne
		} else if (resource === 'operations') {
			const resposne = httpClient(`${apiUrl}/${resource}/deleteOperationList?${stringify(query)}`,options).then(({ headers, json }) => {
				if(json['error']){
				return	Promise.reject((json['error']));
				}
				else{
				return ({
					data: params.ids 
					})
					}});
			return resposne
		} else if (resource === 'orders') {
			const resposne = httpClient(`${apiUrl}/${resource}/deleteOrderList?${stringify(query)}`,options).then(({ headers, json }) => {
				if(json['error']){
				return	Promise.reject((json['error']));
				}
				else{
				return ({
					data: params.ids 
					})
					}});
			return resposne
		} else if (resource === 'admins') {
			const resposne = httpClient(`${apiUrl}/${resource}/deleteAdminList?${stringify(query)}`,options).then(({ headers, json }) => {
				if(json['error']){
				return	Promise.reject((json['error']));
				}
				else{
				return ({
					data: params.ids 
					})
					}});
			return resposne
		}
	},
};
